import { Checkbox, Col, Collapse, InputNumber, Row, Slider } from 'antd';
import { TemplateConfig } from '../../../Templar/RenderPdfPrescription';
import { LocalTemplateConfig, NO_HEADER } from '../EditTemplate';
import PhotoGrid from '../common/PhotoGrid';
import { checkIfImageSizeExceedAndNotify } from '../common/utils';
import { useState } from 'react';
import ImageCrop from '../common/ImageCrop';
import { AntTooltip } from '../../../components/common/AntTooltip';
const { Panel } = Collapse;

const Header: React.FC<{
    rxConfig: TemplateConfig | undefined;
    rxLocalConfig: LocalTemplateConfig | undefined;
    saveRxConfigInState: (rxObj: TemplateConfig) => void;
    saveRxLocalConfigInState: (rxObj: LocalTemplateConfig) => void;
    templateTypeTab: 'PRINT' | 'SEND';
    isHeaderLoading: boolean;
    uploadHeaderImage: (file: File, type: 'PRINT' | 'SEND') => Promise<void>;
    uploadCroppedHeader: (file: File) => Promise<void>;
}> = ({
    rxConfig,
    rxLocalConfig,
    saveRxConfigInState,
    saveRxLocalConfigInState,
    templateTypeTab,
    isHeaderLoading,
    uploadHeaderImage,
    uploadCroppedHeader,
}) => {
    const [cropHeader, setCropHeader] = useState(false);

    const openCropHeader = () => {
        setCropHeader(true);
    };
    const closeCropHeader = () => {
        setCropHeader(false);
    };

    return (
        <>
            <Collapse
                expandIcon={() => (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                        className="w-20 h-20 fill-darwin-accent-medicines-pink-800"
                    >
                        <path d="M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zM216 408V305.9l31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31V408c0 13.3 10.7 24 24 24s24-10.7 24-24z" />
                    </svg>
                )}
            >
                <Panel
                    header={<div className="font-700">Header</div>}
                    key="1"
                    extra={
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                saveRxLocalConfigInState({
                                    header_auto_adjust: !rxLocalConfig?.header_auto_adjust,
                                });
                            }}
                            className="flex items-center space-x-4 cursor-pointer"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 640 512"
                                className="h-16 w-16 rotate-90 transform-gpu fill-neutral-3"
                            >
                                <path d="M32 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96C0 78.3 14.3 64 32 64zm214.6 73.4c12.5 12.5 12.5 32.8 0 45.3L205.3 224l229.5 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 288l-229.5 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM640 96V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z" />
                            </svg>
                            <span className="font-700">AutoFit Height</span>
                            <span>
                                <Checkbox
                                    style={{
                                        margin: 0,
                                    }}
                                    checked={rxLocalConfig?.header_auto_adjust}
                                ></Checkbox>
                            </span>
                        </div>
                    }
                >
                    <div className="space-y-8">
                        {templateTypeTab === 'PRINT' && (
                            <div className="flex items-center space-x-8">
                                <div className="flex w-150 items-center justify-between">
                                    <span>No header: </span>
                                    <Checkbox
                                        checked={rxConfig?.header_img === NO_HEADER ? true : false}
                                        onClick={(e) => {
                                            if (rxConfig?.header_img === NO_HEADER) {
                                                saveRxConfigInState({
                                                    header_img: '',
                                                    // header_height:
                                                    header_height:
                                                        rxConfig?.header_height &&
                                                        rxConfig?.floating_patient_details
                                                            ? `${parseFloat(
                                                                  rxConfig.header_height || '6.2',
                                                              )}cm`
                                                            : '3.2cm',
                                                });
                                            } else {
                                                saveRxConfigInState({
                                                    header_img: NO_HEADER,
                                                    // header_height: '0cm',
                                                    // header_bottom_margin: '',
                                                    // header_left_margin: '',
                                                    // header_right_margin: '',
                                                    // header_top_margin: '',

                                                    header_height: rxConfig?.floating_patient_details
                                                        ? rxConfig?.header_height || '3cm'
                                                        : '0cm',
                                                    header_bottom_margin: rxConfig?.floating_patient_details
                                                        ? rxConfig?.header_bottom_margin
                                                        : '',
                                                    header_left_margin: rxConfig?.floating_patient_details
                                                        ? rxConfig?.header_left_margin
                                                        : '',
                                                    header_right_margin: rxConfig?.floating_patient_details
                                                        ? rxConfig?.header_right_margin
                                                        : '',
                                                    header_top_margin: rxConfig?.floating_patient_details
                                                        ? rxConfig?.header_top_margin
                                                        : '',

                                                    //this will be cleaner and remove the ambiguity if we just disable the show pt details on all page instead of still keeping it in header since then the expectation will be to have same feature in case of image also and we cant technically support that as of now
                                                    // floating_patient_details: false,
                                                });
                                            }
                                        }}
                                    ></Checkbox>
                                </div>
                                <div className="border-r h-24 border-darwin-neutral-500"></div>

                                <div className="flex flex-1 items-center justify-between">
                                    <span>Show header only in 1st page: </span>
                                    <Checkbox
                                        checked={rxConfig?.floating_header}
                                        onClick={() => {
                                            rxConfig?.floating_patient_details === true
                                                ? saveRxConfigInState({
                                                      floating_header: !rxConfig?.floating_header,
                                                      // header_height: '0cm',
                                                      floating_patient_details: false,
                                                      header_height: rxConfig?.header_height
                                                          ? `${Math.max(
                                                                parseFloat(rxConfig.header_height) -
                                                                    3,
                                                                0,
                                                            )}cm`
                                                          : '3.2cm',
                                                  })
                                                : saveRxConfigInState({
                                                      floating_header: !rxConfig?.floating_header,
                                                      floating_patient_details: false,
                                                  });
                                        }}
                                    ></Checkbox>
                                </div>
                            </div>
                        )}
                        <div className="border-b border-darwin-neutral-200 mx-8"></div>
                        <div className="flex flex-1 items-center justify-between">
                            <AntTooltip content="Print Patient Details on Every Page  isn't supported if header is printed on only 1st page">
                                <span>Show Patient Details with Header in every page : </span>
                            </AntTooltip>
                            <Checkbox
                                checked={rxConfig?.floating_patient_details}
                                onClick={() => {
                                    //For better user exp will disable the floating header flag so when they select repeat pt details on all page. "show header only in 1st page is disabled if was enabled before"
                                    !rxConfig?.floating_patient_details &&
                                    rxConfig?.floating_header === true
                                        ? saveRxConfigInState({
                                              floating_patient_details: !rxConfig?.floating_patient_details,
                                              floating_header: false,
                                              header_height: rxConfig?.header_height
                                                  ? `${parseFloat(rxConfig.header_height) + 3}cm`
                                                  : '3.2cm',
                                          })
                                        : !rxConfig?.floating_patient_details
                                        ? saveRxConfigInState({
                                              floating_patient_details: !rxConfig?.floating_patient_details,
                                              header_height: rxConfig?.header_height
                                                  ? `${parseFloat(rxConfig.header_height) + 3}cm`
                                                  : '3.2cm',
                                          })
                                        : saveRxConfigInState({
                                              floating_patient_details: !rxConfig?.floating_patient_details,
                                              header_height: rxConfig?.header_height
                                                  ? `${Math.max(
                                                        parseFloat(rxConfig.header_height) - 3,
                                                        0,
                                                    )}cm`
                                                  : '3.2cm',
                                              // header_height: '0cm',
                                          });
                                }}
                            ></Checkbox>
                        </div>
                        {rxConfig?.header_img !== NO_HEADER && (
                            <>
                                {templateTypeTab === 'PRINT' && (
                                    <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                )}
                                <div className="flex items-center justify-between pb-8">
                                    <p>Header Image:</p>
                                    {rxConfig?.header_img && (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            className="w-16 cursor-pointer fill-neutral-3"
                                            onClick={openCropHeader}
                                        >
                                            <path d="M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32V64H32C14.3 64 0 78.3 0 96s14.3 32 32 32H64V384c0 35.3 28.7 64 64 64H352V384H128V32zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32V448h32c17.7 0 32-14.3 32-32s-14.3-32-32-32H448l0-256c0-35.3-28.7-64-64-64L160 64v64l224 0 0 352z" />
                                        </svg>
                                    )}
                                </div>
                                <div>
                                    <PhotoGrid
                                        isLoading={isHeaderLoading}
                                        photoLink={rxConfig?.header_img}
                                        onPhotoDeleteClick={() =>
                                            saveRxConfigInState({
                                                header_img: '',
                                            })
                                        }
                                        onPhotoSubmit={(file) => {
                                            if (!checkIfImageSizeExceedAndNotify(file)) {
                                                uploadHeaderImage(file, templateTypeTab);
                                            }
                                        }}
                                    />
                                </div>
                            </>
                        )}

                        {!rxConfig?.floating_header && (
                            <>
                                <div className="border-b border-darwin-neutral-200 mx-8"></div>
                                <div className="space-y-4">
                                    <div className="flex items-center justify-between">
                                        <div>Header Height</div>
                                    </div>
                                    <Row>
                                        <Col span={12}>
                                            <Slider
                                                value={parseFloat(rxConfig?.header_height || '')}
                                                min={0}
                                                max={12}
                                                step={1}
                                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                                // @ts-ignore
                                                railStyle={{
                                                    background: '#cccfdb',
                                                }}
                                                onChange={(value) => {
                                                    saveRxConfigInState({
                                                        header_height: `${value}cm`,
                                                    });
                                                }}
                                            />
                                        </Col>
                                        <div className="flex items-center">
                                            <InputNumber
                                                type={'number'}
                                                min={0}
                                                max={12}
                                                style={{
                                                    margin: '0 16px',
                                                }}
                                                value={parseFloat(rxConfig?.header_height || '')}
                                                onChange={(value) => {
                                                    saveRxConfigInState({
                                                        header_height: `${value}cm`,
                                                    });
                                                }}
                                            />

                                            <div>cm</div>
                                        </div>
                                    </Row>
                                </div>
                            </>
                        )}

                        <div className="border-b border-darwin-neutral-200 mx-8"></div>
                        <div className="flex items-center justify-between">
                            <div>Header Aligner:</div>{' '}
                            <div className="space-x-8">
                                <span>Inspect:</span>
                                <Checkbox
                                    checked={rxLocalConfig?.header_border}
                                    onClick={() => {
                                        saveRxLocalConfigInState({
                                            header_border: !rxLocalConfig?.header_border,
                                        });
                                    }}
                                ></Checkbox>
                            </div>
                        </div>
                        {rxConfig?.header_img === NO_HEADER ? (
                            <Row className="space-y-8">
                                <div className="flex flex-1 items-center space-x-8 justify-between">
                                    <span>Top margin: </span>
                                    <div className="flex items-center">
                                        <InputNumber
                                            type={'number'}
                                            min={0}
                                            max={12}
                                            style={{ margin: '0 8px' }}
                                            value={parseFloat(rxConfig?.header_top_margin || '')}
                                            onChange={(value) => {
                                                saveRxConfigInState({
                                                    header_top_margin: `${value}cm`,
                                                });
                                            }}
                                        />
                                        <div>cm</div>
                                    </div>
                                </div>
                            </Row>
                        ) : (
                            <Row className="space-y-8">
                                <div className="flex flex-1 items-center space-x-8 justify-between">
                                    <div>
                                        <span>top: </span>
                                        <div className="flex items-center">
                                            <InputNumber
                                                type={'number'}
                                                min={0}
                                                max={12}
                                                style={{
                                                    margin: '0 8px',
                                                }}
                                                value={parseFloat(
                                                    rxConfig?.header_top_margin || '',
                                                )}
                                                onChange={(value) => {
                                                    saveRxConfigInState({
                                                        header_top_margin: `${value}cm`,
                                                    });
                                                }}
                                            />
                                            <div>cm</div>
                                        </div>
                                    </div>
                                    <div>
                                        {/* <span>bottom: </span>
                                        <div className="flex items-center">
                                            <InputNumber
                                                type={'number'}
                                                min={0}
                                                max={100}
                                                style={{
                                                    margin: '0 8px',
                                                }}
                                                value={parseFloat(
                                                    rxConfig?.header_bottom_margin || '',
                                                )}
                                                onChange={(value) => {
                                                    saveRxConfigInState({
                                                        header_bottom_margin: `${value}cm`,
                                                    });
                                                }}
                                            />
                                            <div>cm</div>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="flex flex-1 items-center space-x-8 justify-between">
                                    <div>
                                        <span>left: </span>
                                        <div className="flex items-center">
                                            <InputNumber
                                                type={'number'}
                                                min={0}
                                                max={12}
                                                style={{
                                                    margin: '0 8px',
                                                }}
                                                value={parseFloat(
                                                    rxConfig?.header_left_margin || '',
                                                )}
                                                onChange={(value) => {
                                                    saveRxConfigInState({
                                                        header_left_margin: `${value}cm`,
                                                    });
                                                }}
                                            />
                                            <div>cm</div>
                                        </div>
                                    </div>
                                    <div>
                                        <span>right: </span>
                                        <div className="flex items-center">
                                            <InputNumber
                                                type={'number'}
                                                min={0}
                                                max={12}
                                                style={{
                                                    margin: '0 8px',
                                                }}
                                                value={parseFloat(
                                                    rxConfig?.header_right_margin || '',
                                                )}
                                                onChange={(value) => {
                                                    saveRxConfigInState({
                                                        header_right_margin: `${value}cm`,
                                                    });
                                                }}
                                            />
                                            <div>cm</div>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        )}
                    </div>
                </Panel>
            </Collapse>
            {cropHeader && (
                <ImageCrop
                    image={rxConfig?.header_img || ''}
                    close={closeCropHeader}
                    isOpen={cropHeader}
                    upload={uploadCroppedHeader}
                />
            )}
        </>
    );
};

export default Header;
